export class UserMediaError extends Error {
}